import React, { useCallback, useState } from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import Button from '~/app/common/Button';
import { TrainingDetail, TRAINING_STATUS } from '~/training/types';
import ApproveTraining from '../ApproveTraining';

export interface TrainingActionsProps {
  training: TrainingDetail;
}

export type TrainingActionsComponent = React.FC<TrainingActionsProps>;

const TrainingActions: TrainingActionsComponent = ({ training }) => {
  const { t } = useTranslation('training');
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [status, setStatus] = useState<TRAINING_STATUS>(TRAINING_STATUS.PENDING);

  const handleOnActionClick = useCallback((nextStatus: TRAINING_STATUS) => {
    setStatus(nextStatus);
    setIsConfirmationOpen(true);
  }, []);

  if (training.status !== TRAINING_STATUS.PENDING) {
    return null;
  }

  return (
    <>
      <div className={classes['footer']}>
        <Button
          className={classes['approve']}
          onClick={() => handleOnActionClick(TRAINING_STATUS.APPROVE)}
        >
          {t('approve')}
        </Button>
        <Button
          className={classes['reject']}
          onClick={() => handleOnActionClick(TRAINING_STATUS.REJECT)}
        >
          {t('reject')}
        </Button>
      </div>
      <ApproveTraining
        open={isConfirmationOpen}
        status={status}
        onClose={() => setIsConfirmationOpen(false)}
      />
    </>
  );
};

export default TrainingActions;
